import { useMemo } from 'react';

import type { MetadataFieldOptionsSchema } from '@iconik-io/iconik-api/src/services/metadata';

import type { MultiSelectFilterFieldWrapperProps } from '../multi_select_filter_field/multi_select_filter_field_wrapper';
import { MultiSelectFilterFieldWrapper } from '../multi_select_filter_field/multi_select_filter_field_wrapper';
import { makeDropDownOptions } from '../multi_select_filter_field/option_hooks';

type MultiSelectFilterDropDownFieldProps = Pick<
  MultiSelectFilterFieldWrapperProps,
  | 'name'
  | 'value'
  | 'onChange'
  | 'label'
  | 'subtitle'
  | 'vertical'
  | 'disabled'
  | 'availableModifiers'
  | 'maxRows'
> & {
  options: MetadataFieldOptionsSchema[];
};

export function MultiSelectFilterDropDownField({
  options,
  ...props
}: MultiSelectFilterDropDownFieldProps) {
  const dropDownOptions = useMemo(
    () => makeDropDownOptions(options),
    [options],
  );

  return <MultiSelectFilterFieldWrapper {...props} {...dropDownOptions} />;
}
